var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.66651 12.9607C7.44524 12.988 7.22252 13.0018 6.99957 13.0021C3.68448 13.0021 0.99707 10.3147 0.99707 6.99957C0.99707 3.68448 3.68448 0.99707 6.99957 0.99707C10.3147 0.99707 13.0021 3.68448 13.0021 6.99957C13.0018 7.22252 12.988 7.44524 12.9607 7.66651",
    stroke: "#D43338",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M12.6677 11.001L11.001 12.6683",
    stroke: "#D43338",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M11.002 11.001L12.6686 12.6683",
    stroke: "#D43338",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M4.99851 9.50089V6.44629",
    stroke: "#D43338",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M6.99949 9.50089V6.44629",
    stroke: "#D43338",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M9.00046 9.50089V6.44629",
    stroke: "#D43338",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M4.33203 9.50046H9.66759",
    stroke: "#D43338",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33203 6.44599H9.66759V5.25683L6.99981 4.16504L4.33203 5.25683V6.44599Z",
    stroke: "#D43338",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDecline);
export default __webpack_public_path__ + "static/media/bank-decline.5e308c8d7d9b31b9c937c643b6a2daee.svg";
export { ForwardRef as ReactComponent };